import React from "react";
import { Provider } from "react-redux";
import jwtDecode from "jwt-decode";
import PublicRoutes from "routers/router";
import { store, history } from "stores/store";
import setAuthToken from "utils/setAuthToken";
import { logoutUser } from "actions/auth/actions";
import "antd/dist/antd.css";
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";
// import "App.css";

import {
    AUTH_USER_SET
} from "actions/auth/constants";

document.cookie = "TOK=_iMedMiMoJw7dc3ojV1=b90zX!dt63uwTa8gq4I; path=/";
// Check for token
if (localStorage.jwtToken) {
    // Set auth token header auth
    setAuthToken(localStorage.jwtToken);
    // Decode token and get user info and exp
    const decoded = jwtDecode(localStorage.jwtToken);
    // Set user and isAuthenticated
    store.dispatch({
        type: AUTH_USER_SET,
        payload: {
            user: decoded,
            roles: JSON.parse(localStorage.roles)
        }
    });

    // Check for expired token
    const currentTime = Math.ceil(Date.now() / 1000);
    if (decoded.exp < currentTime) {
        // Logout user
        store.dispatch(logoutUser());
        // Redirect to login
        window.location.href = "/";
    }
}

const App = () => (
    <Provider store={store}>
        <PublicRoutes history={history} />
    </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js